module.exports = __webpack_public_path__ + "static/media/stop.d2411bd9.svg";